import React from "react";

const Header = () => {
  return (
    <div className="header">
      <div className="header-title">CHARACTER BUILDER</div>
      <div className="header-divider"></div>
    </div>
  );
};

export default Header;
